import { render, staticRenderFns } from "./BrandEditHandler.vue?vue&type=template&id=afb96bb8"
import script from "./BrandEditHandler.vue?vue&type=script&lang=ts"
export * from "./BrandEditHandler.vue?vue&type=script&lang=ts"
import style0 from "./BrandEditHandler.vue?vue&type=style&index=0&id=afb96bb8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports